import '@/shared/assets/scss/styles.scss'
import '@/shared/assets/css/fonts.css'
import '@/shared/assets/css/tailwind.css'
import '@/shared/assets/css/animation.css'
import '@/shared/assets/css/skeleton.css'
import '@/shared/assets/css/html.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { amplitudePlugin } from '@/shared/plugins/amplitude'
import { analyticsPlugin } from '@/shared/plugins/analytics'
import { api } from '@/shared/plugins/api'
import { gtagPlugin } from '@/shared/plugins/gtag'
import { i18nPlugin } from '@/shared/plugins/i18n'
import { modalPlugin } from '@/shared/plugins/modal'
import { sentryPlugin } from '@/shared/plugins/sentry'
import 'webrtc-adapter'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
sentryPlugin(app, router)
app.use(i18nPlugin())
app.use(api.apiPlugin)
app.use(modalPlugin)
app.use(amplitudePlugin)
app.use(gtagPlugin)
app.use(analyticsPlugin)

app.mount('#app')
